import useImperativeDialog from '@/components/shared/dialogs/useImperativeDialog';
import { Dialog } from '@/components/ui/dialog';
import { ImperativeDialogRef } from '@/components/shared/dialogs/useImperativeDialogRef';

import { forwardRef } from 'react';

const AppDialog = forwardRef<
  ImperativeDialogRef,
  React.ComponentProps<typeof Dialog>
>(({ children, ...otherProps }, modalRef) => {
  const { isOpen, onOpenChange } = useImperativeDialog(modalRef);
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange} {...otherProps}>
      {children}
    </Dialog>
  );
});
AppDialog.displayName = 'AppModal';
export default AppDialog;
